import {i18n} from '../ctx/I18n'
import {System} from './System'
import {DateUtil} from "../lib/DateUtil";
import {NumberUtil} from "../lib/NumberUtil";

const projectColumns = [
    { field: 'project_ref',         headerName: 'Projekt Nr',                   type: 'string',  width: 150, sortable: true },
    { field: 'project_desc',        headerName: 'Beschreibung',                 type: 'string',  width: 200, sortable: false},
    { field: 'architect',           headerName: 'Auftraggeber',                 type: 'string',  width: 200, sortable: true },
    { field: 'initial_date',        headerName: 'Planungsdatum',                type: 'string',  width: 150, sortable: true },
    { field: 'address',             headerName: 'Adresse',                      type: 'string',  width: 200, sortable: true },
    { field: 'zip',                 headerName: 'PLZ',                          type: 'string',  width: 100, sortable: true },
    { field: 'city',                headerName: 'Ort',                          type: 'string',  width: 100, sortable: true },
    { field: 'sm_name',             headerName: 'Bauleiter',                    type: 'string',  width: 100, sortable: true },
    { field: 'sm_phone',            headerName: 'Bauleiter Telefon',            type: 'string',  width: 100, sortable: true },
    { field: 'sm_email',            headerName: 'Bauleiter E-Mail',             type: 'string',  width: 100, sortable: true },
    { field: 'avorAmountLabel',     headerName: 'Auftragssumme',                type: 'string',  width: 130, sortable: true },
    { field: 'avorStateLabel',      headerName: 'Vorausmass',                   type: 'string',  width: 100, sortable: true },
    { field: 'avorCreatedBy',       headerName: 'Vorausmass erstellt von',      type: 'string',  width: 200, sortable: true },
    { field: 'avor_created_at',     headerName: 'Vorausmass erstellt am',       type: 'string',  width: 200, sortable: true },
    { field: 'avorCreatedLabel',    headerName: 'Vorausmass erstellt',          type: 'string',  width: 200, sortable: true },
    { field: 'foreman',             headerName: 'Bauführer (Stellvertreter)',   type: 'string',  width: 240, sortable: true },
    // { field: 'doc_count',        headerName: 'Dok',                          type: 'number',  width:  80, sortable: false},

    { field: 'prep1Label',          headerName: i18n.prep1,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep2Label',          headerName: i18n.prep2,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep3Label',          headerName: i18n.prep3,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep4Label',          headerName: i18n.prep4,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep5Label',          headerName: i18n.prep5,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep6Label',          headerName: i18n.prep6,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep7Label',          headerName: i18n.prep7,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep8Label',          headerName: i18n.prep8,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep9Label',          headerName: i18n.prep9,                     type: 'string',  width: 100, sortable: true},
    { field: 'prep_info',           headerName: i18n.prepInfo,                  type: 'string',  width: 100, sortable: true },

    { field: 'closedLabel',         headerName: 'Abgeschlossen',                type: 'string',  width: 120, sortable: false},
    { field: 'id',                  headerName: 'Id',                           type: 'number',  width:  80, sortable: true }
]

const projectColumnsMap = Object.fromEntries(projectColumns.map(col => [col.field, col]));

export const Project = {

    getArchiveColumns() {
        const fields = [
            'project_ref', 'project_desc', 'architect',
            'address', 'zip', 'city',
            'sm_name', 'sm_phone', 'sm_email',
            'initial_date', 'avorAmountLabel', 'avorStateLabel',
            'foreman',
            'prep1Label', 'prep2Label', 'prep3Label', 'prep4Label', 'prep5Label', 'prep_info',
            'closedLabel', 'id'];

        return fields.map(f => projectColumnsMap[f]).filter(Boolean);
    },

    getListColumns(includeClosedColumn=true, includeSystemColumns = false) {
        const fields = ['project_ref', 'project_desc', 'architect', 'initial_date', 'address', 'zip', 'city',
            'avorStateLabel', 'foreman'];

        if (includeClosedColumn) {
            fields.push('closedLabel');
        }

        fields.push('id');

        const columns = fields.map(f => projectColumnsMap[f]).filter(Boolean);

        if (includeSystemColumns) {
            columns.push(...System.getSystemColumns());
        }

        return columns;
    },

    getListAvorColumns() {
        const fields = ['project_ref', 'project_desc', 'initial_date', 'foreman',
            'avorAmountLabel', 'avorStateLabel', 'avorCreatedBy', 'avor_created_at', 'id'];

        return fields.map(f => projectColumnsMap[f]).filter(Boolean);
    },

    getReportAvorColumns() {
        return this.getListAvorColumns();
    },

    mapListColumns(projects, crew) {
        return projects.map(project => {
            const foremanName = crew.getName(project.foreman_crew_id);
            const deputyName  = crew.getName(project.deputy_foreman_crew_id);
            const foremanLabel = deputyName ? `${foremanName} (${deputyName})` : foremanName;
            const closedLabel= project.closed === 1 ? "Ja" : "Nein";

            const avorAmountLabel = NumberUtil.formatCHF(project.avor_amount);
            const avorStateLabel = this.getAvorStateLabel(project.avor_state);

            const avorCreatedBy = crew.getName(project.avor_created_crew_id);
            const avorCreatedAt = DateUtil.convertIsoStringToString(project.avor_created_at);
            const avorCreatedLabel = avorCreatedAt ? `${avorCreatedBy} (${avorCreatedAt})` : avorCreatedBy;

            const prep1Label= this.getPrepStateLabel(project.prep_1);
            const prep2Label= this.getPrepStateLabel(project.prep_2);
            const prep3Label= this.getPrepStateLabel(project.prep_3);
            const prep4Label= this.getPrepStateLabel(project.prep_4);
            const prep5Label= this.getPrepStateLabel(project.prep_5);
            const prep6Label= this.getPrepStateLabel(project.prep_6);
            const prep7Label= this.getPrepStateLabel(project.prep_7);
            const prep8Label= this.getPrepStateLabel(project.prep_8);
            const prep9Label= this.getPrepStateLabel(project.prep_9);

            return {
                ...project,
                avorAmountLabel : avorAmountLabel,
                avorStateLabel  : avorStateLabel,
                avorCreatedBy   : avorCreatedBy,
                avorCreatedAt   : avorCreatedAt,
                avorCreatedLabel: avorCreatedLabel,
                foreman: foremanLabel,
                closedLabel: closedLabel,
                prep1Label: prep1Label,
                prep2Label: prep2Label,
                prep3Label: prep3Label,
                prep4Label: prep4Label,
                prep5Label: prep5Label,
                prep6Label: prep6Label,
                prep7Label: prep7Label,
                prep8Label: prep8Label,
                prep9Label: prep9Label,
            };
        });
    },

    getFormValues() {
        return {
            "id"                    : null,
            "project_ref"           : "",
            "project_desc"          : "",
            "architect"             : "",
            "initial_date"          : null,
            "address"               : "",
            "zip"                   : "",
            "city"                  : "",
            "sm_name"               : "",
            "sm_phone"              : "",
            "sm_email"              : "",
            "foreman_crew_id"       : -1,
            "deputy_foreman_crew_id": -1,
            "avor_amount"           : null,
            "avor_state"            : -1,
            "avor_created_crew_id"  : -1,
            "avor_created_at"       : null,
            "prep_1"                : 0,
            "prep_2"                : 0,
            "prep_3"                : 0,
            "prep_4"                : 0,
            "prep_5"                : 0,
            "prep_6"                : 0,
            "prep_7"                : 0,
            "prep_8"                : 0,
            "prep_9"                : 0,
            "prep_info"             : "",
            "closed"                : 0,
            "version"               : 0,
            "insert_ts"             : "",
            "insert_by"             : "",
            "update_ts"             : "",
            "update_by"             : ""
        }
    },

    getFormErrors() {
        return System.initializeFormErrors(Project.getFormValues());
    },

    getFormRequiredFields() {
       return [
           "project_ref",
           "project_desc",
           "architect",
           "initial_date",
           "address",
           "zip",
           "city"
       ];
    },

    // Converts DB values to form-friendly values
    mapDbToForm(dbValues) {
        const values = { ...dbValues };

        if (values.foreman_crew_id === null) {
            values.foreman_crew_id = -1;
        }

        if (values.deputy_foreman_crew_id === null) {
            values.deputy_foreman_crew_id = -1;
        }

        if (values.avor_state === null) {
            values.avor_state = -1;
        }

        if (values.avor_created_crew_id === null) {
            values.avor_created_crew_id = -1;
        }


        // Beachte: Aktuell sind auf DB nur 0 (Nein) oder 1 (Ja) vorhanden. Mapping bleibt aktuell auf -1.
        if (values.prep_1 === null) {
            values.prep_1 = -1;
        }
        if (values.prep_2 === null) {
            values.prep_2 = -1;
        }
        if (values.prep_3 === null) {
            values.prep_3 = -1;
        }
        if (values.prep_4 === null) {
            values.prep_4 = -1;
        }
        if (values.prep_5 === null) {
            values.prep_5 = -1;
        }
        if (values.prep_6 === null) {
            values.prep_6 = -1;
        }
        if (values.prep_7 === null) {
            values.prep_7 = -1;
        }
        if (values.prep_8 === null) {
            values.prep_8 = -1;
        }
        if (values.prep_9 === null) {
            values.prep_9 = -1;
        }

        return values;
    },

    mapFormToDb(formValues) {
        return {
            id                      : formValues.id,
            project_ref             : formValues.project_ref,
            project_desc            : formValues.project_desc,
            architect               : formValues.architect,
            initial_date            : System.mapValueToDb(formValues.initial_date),
            address                 : formValues.address,
            zip                     : formValues.zip,
            city                    : formValues.city,
            sm_name                 : formValues.sm_name,
            sm_phone                : formValues.sm_phone,
            sm_email                : formValues.sm_email,
            foreman_crew_id         : System.mapCodeToDb(formValues.foreman_crew_id),
            deputy_foreman_crew_id  : System.mapCodeToDb(formValues.deputy_foreman_crew_id),
            avor_amount             : formValues.avor_amount,
            avor_state              : System.mapCodeToDb(formValues.avor_state),
            avor_created_crew_id    : System.mapCodeToDb(formValues.avor_created_crew_id),
            avor_created_at         : System.mapValueToDb(formValues.avor_created_at),
            prep_1                  : System.mapCodeToDb(formValues.prep_1),
            prep_2                  : System.mapCodeToDb(formValues.prep_2),
            prep_3                  : System.mapCodeToDb(formValues.prep_3),
            prep_4                  : System.mapCodeToDb(formValues.prep_4),
            prep_5                  : System.mapCodeToDb(formValues.prep_5),
            prep_6                  : System.mapCodeToDb(formValues.prep_6),
            prep_7                  : System.mapCodeToDb(formValues.prep_7),
            prep_8                  : System.mapCodeToDb(formValues.prep_8),
            prep_9                  : System.mapCodeToDb(formValues.prep_9),
            prep_info               : System.mapValueToDb(formValues.prep_info),
            closed                  : formValues.closed,
            version                 : formValues.version
        }
    },

    getAvorStateItems() {
        return [
            {label: "",         value :-1},
            {label: "Nein",     value :0},
            {label: "Pendent",  value :1},
            {label: "Erfasst",  value :2}
        ]
    },

    getAvorStateLabel(value) {
        const item = this.getAvorStateItems().find(i => i.value === value);
        return item ? item.label : "";
    },

    getPrepStateItems() {
        return [
            {label: "Ja",   value :1},
            {label: "Nein", value :0}
        ]
    },

    getPrepStateLabel(value) {
        const item = this.getPrepStateItems().find(i => i.value === value);
        return item ? item.label : "";
    },

    getSearchClosedItems() {
        return [
            {label: "Alle", value :-1},
            {label: "Ja",   value :1},
            {label: "Nein", value :0}
        ]
    },

    getSearchValues() {
        return {
            "project_ref"           : "",
            "project_desc"          : "",
            "architect"             : "",
            "start_initial_date"    : null,
            "end_initial_date"      : null,
            "address"               : "",
            "zip"                   : "",
            "city"                  : "",
            "sm_name"               : "",
            "sm_phone"              : "",
            "sm_email"              : "",
            "avor_amount_from"      : "",
            "avor_amount_to"        : "",
            "avor_state"            : -1,
            "avor_created_crew_id"  : -1,
            "avor_created_at"       : null,
            "foreman_crew_id"       : -1,
            "deputy_foreman_crew_id": -1,
            "closed"                : -1            // Radiobox mit: -1=Alle, 0=nicht abgeräumt, 1=abgeräumt
        }
    },

    getSearchErrors() {
        return System.initializeFormErrors(Project.getSearchValues());
    },

    getSearchMinimalLength() {
        return {
            "project_ref"       : 4,
            "project_desc"      : 4,
            "architect"         : 4,
            "address"           : 4,
            "zip"               : 4,
            "city"              : 3,
            "sm_name"           : 4,
            "sm_phone"          : 4,
            "sm_email"          : 4
        }
    },

    mapSearchToQuery(searchValues) {
        return {
            "project_ref"           : System.mapValueToQuery(searchValues.project_ref),
            "project_desc"          : System.mapValueToQuery(searchValues.project_desc),
            "architect"             : System.mapValueToQuery(searchValues.architect),
            "start_initial_date"    : System.mapValueToQuery(searchValues.start_initial_date),
            "end_initial_date"      : System.mapValueToQuery(searchValues.end_initial_date),
            "address"               : System.mapValueToQuery(searchValues.address),
            "zip"                   : System.mapValueToQuery(searchValues.zip),
            "city"                  : System.mapValueToQuery(searchValues.city),
            "sm_name"               : System.mapValueToQuery(searchValues.sm_name),
            "sm_phone"              : System.mapValueToQuery(searchValues.sm_phone),
            "sm_email"              : System.mapValueToQuery(searchValues.sm_email),
            "avor_amount_from"      : System.mapValueToQuery(searchValues.avor_amount_from),
            "avor_amount_to"        : System.mapValueToQuery(searchValues.avor_amount_to),
            "avor_state"            : System.mapCodeToQuery(searchValues.avor_state),
            "avor_created_crew_id"  : System.mapCodeToQuery(searchValues.avor_created_crew_id),
            "avor_created_at"       : System.mapValueToQuery(searchValues.avor_created_at),
            "foreman_crew_id"       : System.mapCodeToQuery(searchValues.foreman_crew_id),
            "deputy_foreman_crew_id": System.mapCodeToQuery(searchValues.deputy_foreman_crew_id),
            "closed"                : System.mapCodeToQuery(searchValues.closed)
        }
    }

};

